import React, {useState} from "react";
import KidneyPancreas from "../../../assets/images/organs/72x72/Kidney-pancreas.png";
import KidneyPancreasHover from "../../../assets/images/organs/72x72/Kidney-pancreas-Over.png";

function KidneyPancreasIcon(props) {
    const [isHover, setIsHover] = useState(false);

    if (props.showHover) {
        return (
            <div 
                className={props.count ? "icon-container organ-count-wrapper" : "icon-container"}
                onMouseEnter={()=> setIsHover(true)}
                onMouseLeave={()=> setIsHover(false)}
            >
                <img src={isHover ? KidneyPancreasHover : KidneyPancreas} alt="Heart Lung Icon" className="organ-icon large" />
                {props.count &&
                    <div className="organ-count kidney-pancreas">
                        {props.count}
                    </div>
                }
                
            </div>
        );
    }
    else {
        return (<img src={KidneyPancreas} alt="Heart Lung Icon" className="organ-icon large" />);
    }
}

export default KidneyPancreasIcon;